<template><div><h1 id="esr-fehlerliste-mutiert-nach-user" tabindex="-1"><a class="header-anchor" href="#esr-fehlerliste-mutiert-nach-user"><span>ESR Fehlerliste mutiert nach User</span></a></h1>
<p>ESR Fehlerliste mutiert nach User — Listet die Anzahl mutierten fehlerhaften Buchungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Statistik listet die Anzahl mutierten fehlerhaften Buchungen pro User auf, die beim Buchungen einlesen entstehen können.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Auswertungen → Datenerfassung → ESR Fehlerliste mutiert nach User</code></p>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Ausgegeben wird die Anzahl mutierter Buchungen pro User.</p>
</div></template>


